$(document).ready(() => {
  const $button = $('#sign-partnership-contract');
  const $spinner = $button.find(".signature-loader");
  const $nextButton = $('#sign-partnership-contract-success');

  $button.on('click', function(e) {
    e.preventDefault();
    $(this).attr('disabled', true);
    $spinner.removeClass('d-none');
    $("#user_terms_accepted").prop("disabled", true);

    App.waiting_list = App.cable.subscriptions.create({
      channel: 'PartnershipContractChannel',
      profile_id: $button.data('id')
    },
    {
      received(data) {
        try {
          if (data.status === 'success') {
            if (data.e_sign_id !== undefined) {
              $button.addClass('d-none');

              $nextButton.removeClass('d-none');
              $nextButton.attr("href", data.next_step_path)
            }
          } else {
            console.log(data.status);
          }
        } catch(error) {
          console.log("catch", error);
        }
      },
      rejected() {
        console.log("rejected");
        this.uninstall();
      }
    });
  });
});
